import { Handlers, Marlin } from '@zg-rentals/marlin';
import { createClient } from '@zg-rentals/http-client';

export class MarlinBrowser extends Marlin {
  constructor(appName: string) {
    // `keepalive` is set here rather than on the shared client because it is browser-only: it gets
    // sendBeacon-like delivery while still allowing custom headers, so a flush during pagehide
    // still lands. On the server it is a no-op in undici, and under Next it throws - ky passes a
    // Request to fetch, Next's patched fetch rebuilds it with a stream body, and undici rejects
    // keepalive with a stream body.
    //
    // Dropping it on the server does not cost us TCP connection reuse - that is the dispatcher's
    // job, not RequestInit's. BootstrapNode.configureKeepalive() installs an undici Agent with
    // keepAliveTimeout 60s so sockets survive between batches.
    super(appName, () => createClient({ keepalive: true, logging: false, monitoring: false }), Handlers.referer, 1_000);
  }
}
